/** Smooth-scroll to the dashboard generator block (`#generator`). */
const GENERATOR_SCROLL_OFFSET_PX = 80

export function useScrollToGenerator() {
  function scrollToGenerator() {
    if (!import.meta.client) return
    const el = document.getElementById('generator')
    if (!el) return
    const top = el.getBoundingClientRect().top + window.scrollY - GENERATOR_SCROLL_OFFSET_PX
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' })
  }

  return { scrollToGenerator }
}
